// extracted by mini-css-extract-plugin
export var borderRadius = "_g5-4";
export var large = "_g5-3";
export var logoContainer = "_g5-0";
export var nameLogo = "_g5-2";
export var small = "_g5-1";